file = "EXT:nordwest/Resources/Public/Images/ImageDefaultSplash.svg";
/*!
 * NORDWEST Handel AG v1.0.0 (https://mokom01.com)
 * Copyright 2017-2023 Mokom01
 * Licensed under the GPL-2.0-or-later license
 */
console.log("WE LOVE NORDWEST");

// Toggle Dropdown menu items
$(".topbar li.dropdown").click(function (e) {
  e.preventDefault();
  $(this).find(".dropdown-menu").toggleClass("open");
});

//======================================================
// globally used functions for sliders
(function ($) {
  ($.videoUtilities = {
    replaceSplashWithVideo: function (splash) {
      let iframe = splash.closest(".video").find(".video-iframe").html();
      splash.replaceWith(iframe);
    },

    stopAllVideos: function (elementContainer) {
      let videos = elementContainer.find("iframe, video");
      videos.each(function () {
        if ($(this).prop("tagName") === "VIDEO") {
          $(this)[0].pause();
        } else {
          if ($(this).attr("src")) {
            let src =
              $(this).attr("src").replace("autoplay=1", "") + "&autoplay=0";
            $(this).attr("src", src);
          }
        }
      });
    },
  }),
    ($.sliderUtilities = {
      // because of bug: after touchend autostart was initialized
      fixTouchEventAutoScroll: function (event) {
        let owl = $(event.target);
        owl.on("dragged.owl.carousel", function (event) {
          let owl = $(event.target);
          owl.trigger("stop.owl.autoplay");
        });
      },

      getNumberOfItems: function (owl) {
        // since loop:true needs a defined item-property, we have to do some calculation here
        let owlItems = owl.find(".logo-list-item");
        let minWidth = $(window).width();

        // find smallest item
        owlItems.each(function () {
          let itemWidth = $(this).outerWidth();
          if (itemWidth < minWidth) {
            minWidth = itemWidth;
          }
        });
        return Math.ceil($(window).width() / minWidth);
      },

      getPageInfo: function (event) {
        if (event.item) {
          let index = event.item.index + 1;
          let count = event.item.count;
          return index + " / " + count;
        }
        return "";
      },

      setPaginationStatus: function (event) {
        let owl = $(event.target);
        owl
          .closest(".js-carousel-section")
          .find(".js-owl-nav-prev")
          .removeClass("disabled");

        owl
          .closest(".js-carousel-section")
          .find(".js-owl-nav-next")
          .removeClass("disabled");

        owl.closest(".js-carousel-section").find(".js-owl-nav").show();

        // copy state from original nav
        setInterval(
          function (owl) {
            let nav = owl.find(".owl-nav").first();
            let navPrev = nav.find(".owl-prev").first();
            let navNext = nav.find(".owl-next").first();

            if (navPrev.hasClass("disabled")) {
              owl
                .closest(".js-carousel-section")
                .find(".js-owl-nav-prev")
                .addClass("disabled");
            }

            if (navNext.hasClass("disabled")) {
              owl
                .closest(".js-carousel-section")
                .find(".js-owl-nav-next")
                .addClass("disabled");
            }

            if (navPrev.hasClass("disabled") && navNext.hasClass("disabled")) {
              owl.closest(".js-carousel-section").find(".js-owl-nav").hide();
            }
          },
          100,
          owl
        );
      },
    });
})(jQuery);

//======================================================
// needed because if a mobile browser hides/shows the address-bar during scrolling this fires a resize event!
// touchmove is fired on iPad when the scrolling starts, scroll is fired when scrolling ends
let activeScrolling = false;
$(window).on("scroll touchmove", function () {
  activeScrolling = true;
  waitForFinalEvent(
    function () {
      activeScrolling = false;
    },
    500,
    "scrolling"
  );
});

let waitForFinalEvent = (function () {
  let timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout(timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

//======================================================
// Slider for logos
$(".owl-carousel.js-logo-list").each(function (index, element) {
  let owl = $(element);
  let config = {
    items: $.sliderUtilities.getNumberOfItems(owl),
    loop: true,
    dots: false,
    nav: false,
    autoWidth: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
  };

  owl.owlCarousel(config);

  // re-init on resize
  $(window).resize(function () {
    if (!activeScrolling) {
      waitForFinalEvent(
        function () {
          owl.trigger("destroy.owl.carousel");
          owl.owlCarousel(config);
        },
        200,
        "logoSlider" + index
      );
    }
  });
});

//======================================================
// Logo-Random-Slider - only on mobile
$(".owl-carousel.js-logo-list-random").each(function (index, element) {
  let owl = $(element);
  owl.owlCarousel({
    items: 2,
    responsive: {
      576: {
        items: 3,
      },
      768: {
        items: 4,
      },
    },
    loop: true,
    margin: 25,
    dots: false,
    nav: false,
    autoplay: true,
    autoWidth: false,
    autoHeight: false,
    autoplayTimeout: 8000,
    autoplayHoverPause: true,
  });
});

//======================================================
// Content-Slider
$(".owl-carousel.js-cards-no-loop-slider").each(function (index, element) {
  let owl = $(element);
  owl.on("initialized.owl.carousel", function (e) {
    $.sliderUtilities.setPaginationStatus(e);
    $.sliderUtilities.fixTouchEventAutoScroll(e);
  });
  owl.on("changed.owl.carousel", function (e) {
    $.sliderUtilities.setPaginationStatus(e);
  });

  let config = {
    items: 1,
    autoHeight: true,
    responsive: {
      576: {
        items: 1,
        autoHeight: true,
      },
      768: {
        items: 2,
        autoHeight: false,
      },
      1020: {
        items: 3,
        autoHeight: false,
      },
      1200: {
        items: 3,
        autoHeight: false,
      },
      1400: {
        items: 3,
        margin: 50,
        autoHeight: false,
      },
    },
    loop: false,
    margin: 25,
    dots: false,
    nav: true,
    center: false,
    autoplay: false,
    autoWidth: false,
  };

  owl.owlCarousel(config);

  // re-init on resize
  $(window).resize(function () {
    if (!activeScrolling) {
      waitForFinalEvent(
        function () {
          owl.trigger("destroy.owl.carousel");
          owl.owlCarousel(config);
        },
        200,
        "contentSlider" + index
      );
    }
  });

  owl
    .closest(".js-carousel-section")
    .find(".js-owl-nav-prev")
    .on("click", function (e) {
      e.preventDefault();
      owl.trigger("stop.owl.autoplay");
      owl.trigger("prev.owl.carousel");
    });
  owl
    .closest(".js-carousel-section")
    .find(".js-owl-nav-next")
    .on("click", function (e) {
      e.preventDefault();
      owl.trigger("stop.owl.autoplay");
      owl.trigger("next.owl.carousel");
    });
});

//======================================================
// Fact slider
$(".owl-carousel.js-fact-slider").each(function (index, element) {
  let owl = $(element);
  owl.on("initialized.owl.carousel", function (e) {
    $(".fact-slider-status").html($.sliderUtilities.getPageInfo(e));
    $.sliderUtilities.setPaginationStatus(e);
    $.sliderUtilities.fixTouchEventAutoScroll(e);
  });
  owl.on("changed.owl.carousel", function (e) {
    $(".fact-slider-status").html($.sliderUtilities.getPageInfo(e));
    $.sliderUtilities.setPaginationStatus(e);
  });

  let config = {
    items: 1,
    loop: false,
    margin: 10,
    dots: false,
    nav: true,
    autoplay: false,
    autoHeight: true,
  };

  owl.owlCarousel(config);

  // re-init on resize
  $(window).resize(function () {
    if (!activeScrolling) {
      waitForFinalEvent(
        function () {
          owl.trigger("destroy.owl.carousel");
          owl.owlCarousel(config);
        },
        200,
        "factSlider" + index
      );
    }
  });

  owl
    .closest(".js-carousel-section")
    .find(".js-owl-nav-prev")
    .on("click", function (e) {
      e.preventDefault();
      owl.trigger("prev.owl.carousel");
    });
  owl
    .closest(".js-carousel-section")
    .find(".js-owl-nav-next")
    .on("click", function (e) {
      e.preventDefault();
      owl.trigger("next.owl.carousel");
    });
});

//======================================================
// Highlight content slider
$(".owl-carousel.js-highlight-content-slider").each(function (index, element) {
  let owl = $(element);
  owl.owlCarousel({
    items: 1,
    responsive: {
      768: {
        margin: 50,
      },
    },
    loop: false,
    margin: 25,
    dots: true,
    nav: false,
    autoplay: false,
    autoHeight: true,
  });
});

//======================================================
// Quote slider
$(".owl-carousel.js-quote-slider").each(function (index, element) {
  let owl = $(element);
  owl.on("initialized.owl.carousel", function (e) {
    $.sliderUtilities.fixTouchEventAutoScroll(e);
  });

  owl.owlCarousel({
    items: 1,
    autoHeight: true,
    responsive: {
      // 576: {
      // 	autoHeight: false,
      // },
      768: {
        margin: 50,
        //autoHeight: false,
      },
    },
    loop: false,
    margin: 25,
    dots: true,
    nav: true,
    center: false,
    autoplay: false,
    autoWidth: false,
  });
});

//======================================================
// Gallery-Slider
$(".owl-carousel.js-gallery-slider").each(function (index, element) {
  let owl = $(element);
  owl.on("initialized.owl.carousel", function (e) {
    $.sliderUtilities.setPaginationStatus(e);
    $.sliderUtilities.fixTouchEventAutoScroll(e);
  });
  owl.on("changed.owl.carousel", function (e) {
    $.sliderUtilities.setPaginationStatus(e);
  });

  let config = {
    items: 1,
    autoHeight: true,
    responsive: {
      576: {
        items: 1,
        margin: 50,
      },
      768: {
        items: 2,
        margin: 50,
      },
      1200: {
        items: 2,
        margin: 50,
      },
      1400: {
        items: 3,
        margin: 50,
      },
    },
    loop: false,
    margin: 0,
    dots: false,
    nav: true,
    center: false,
    autoplay: false,
    autoWidth: false,
  };

  if (owl.hasClass("js-gallery-slider-big")) {
    config = {
      items: 1,
      autoHeight: true,
      responsive: {
        576: {
          items: 1,
          margin: 50,
        },
        768: {
          items: 2,
          margin: 50,
        },
        1200: {
          items: 2,
          margin: 50,
        },
        // 1400: {
        // 	items: 3,
        //  margin: 50,
        // },
        1920: {
          items: 1,
          margin: 50,
        },
      },
      loop: false,
      margin: 0,
      dots: false,
      nav: true,
      center: false,
      autoplay: false,
      autoWidth: false,
    };
  }

  owl.owlCarousel(config);

  // re-init on resize
  $(window).resize(function () {
    if (!activeScrolling) {
      waitForFinalEvent(
        function () {
          owl.trigger("destroy.owl.carousel");
          owl.owlCarousel(config);
        },
        200,
        "gallerySlider" + index
      );
    }
  });

  /*
  // fixing strange behavior on start which ignores autoplayTimeout from time to time
  owl.attr("data-pause-autoplay", 0);
  owl.attr("data-stop-autoplay", 0);

  setInterval(
    function (owl) {
      if (
        owl.attr("data-pause-autoplay") == 0 &&
        owl.attr("data-stop-autoplay") == 0
      ) {
        owl.trigger("next.owl.carousel");
      }
    },
    7000,
    owl
  );

  owl.on("mouseover", function () {
    owl.attr("data-pause-autoplay", 1);
  });

  owl.on("mouseout", function () {
    owl.attr("data-pause-autoplay", 0);
  });
  */

  owl
    .closest(".js-carousel-section")
    .find(".js-owl-nav-prev")
    .on("click", function (e) {
      e.preventDefault();
      owl.attr("data-stop-autoplay", 1);
      owl.trigger("prev.owl.carousel");
    });
  owl
    .closest(".js-carousel-section")
    .find(".js-owl-nav-next")
    .on("click", function (e) {
      e.preventDefault();
      owl.attr("data-stop-autoplay", 1);
      owl.trigger("next.owl.carousel");
    });
});

//======================================================
// Benefit-Slider
$(".owl-carousel.js-benefit-slider").each(function (index, element) {
  let owl = $(element);
  owl.on("initialized.owl.carousel", function (e) {
    owl
      .find(".owl-item.active")
      .first()
      .find(".benefit-body")
      .addClass("benefit-body-active");
    $.sliderUtilities.setPaginationStatus(e);
  });

  owl.on("changed.owl.carousel", function (e) {
    $.sliderUtilities.setPaginationStatus(e);
  });

  owl.on("dragged.owl.carousel", function (e) {
    owl.find(".benefit-body").removeClass("benefit-body-active");
    owl
      .find(".owl-item.active")
      .first()
      .find(".benefit-body")
      .addClass("benefit-body-active");
    $.sliderUtilities.setPaginationStatus(e);
  });

  let config = {
    items: 1,
    responsive: {
      1400: {
        items: 3,
        margin: 50,
        nav: true,
      },
      1200: {
        items: 3,
        nav: true,
      },
      1020: {
        items: 3,
      },
      768: {
        items: 2,
        margin: 25,
      },
    },
    loop: false,
    margin: 25,
    dots: false,
    autoplay: false,
    nav: true,
  };

  owl.owlCarousel(config);

  // re-init on resize
  $(window).resize(function () {
    if (!activeScrolling) {
      waitForFinalEvent(
        function () {
          owl.trigger("destroy.owl.carousel");
          owl.owlCarousel(config);
        },
        200,
        "benefitSlider" + index
      );
    }
  });

  owl
    .closest(".js-carousel-section")
    .find(".js-owl-nav-prev")
    .on("click", function (e) {
      e.preventDefault();
      owl.trigger("prev.owl.carousel");
      owl.find(".benefit-body").removeClass("benefit-body-active");
      owl
        .find(".owl-item.active")
        .first()
        .find(".benefit-body")
        .addClass("benefit-body-active");
    });
  owl
    .closest(".js-carousel-section")
    .find(".js-owl-nav-next")
    .on("click", function (e) {
      e.preventDefault();
      owl.trigger("next.owl.carousel");
      owl.find(".benefit-body").removeClass("benefit-body-active");
      owl
        .find(".owl-item.active")
        .first()
        .find(".benefit-body")
        .addClass("benefit-body-active");
    });
});

//======================================================
// News-Slider
$(".owl-carousel.js-news-nav").each(function (index, element) {
  let owl = $(element);
  owl.on("initialized.owl.carousel", function (e) {
    $.sliderUtilities.setPaginationStatus(e);
  });
  owl.on("changed.owl.carousel", function (e) {
    $.sliderUtilities.setPaginationStatus(e);
  });

  let config = {
    items: 1,
    loop: true,
    autoHeight: true,
    responsive: {
      576: {
        items: 1,
        autoHeight: true,
      },
      768: {
        items: 2,
        autoHeight: false,
      },
      1020: {
        items: 3,
        autoHeight: false,
      },
      1200: {
        items: 3,
        autoHeight: false,
      },
      1400: {
        items: 3,
        margin: 50,
        autoHeight: false,
      },
    },
    margin: 25,
    dots: false,
    nav: true,
    autoWidth: false,
    center: false,
    autoplay: true,
    autoplayTimeout: 8000,
    autoplayHoverPause: true,
  };

  owl.owlCarousel(config);

  // re-init on resize
  $(window).resize(function () {
    if (!activeScrolling) {
      waitForFinalEvent(
        function () {
          owl.trigger("destroy.owl.carousel");
          owl.owlCarousel(config);
        },
        200,
        "newsSlider" + index
      );
    }
  });

  owl
    .closest(".js-carousel-section")
    .find(".js-owl-nav-prev")
    .on("click", function (e) {
      e.preventDefault();
      owl.trigger("stop.owl.autoplay");
      owl.trigger("prev.owl.carousel");
    });
  owl
    .closest(".js-carousel-section")
    .find(".js-owl-nav-next")
    .on("click", function (e) {
      e.preventDefault();
      owl.trigger("stop.owl.autoplay");
      owl.trigger("next.owl.carousel");
    });
});

//======================================================
// News-Slider
$(".owl-carousel.js-news-highlight").each(function (index, element) {
  let owl = $(element);
  owl.on("initialized.owl.carousel", function (e) {
    $.sliderUtilities.setPaginationStatus(e);
  });
  owl.on("changed.owl.carousel", function (e) {
    $.sliderUtilities.setPaginationStatus(e);
  });

  let config = {
    items: 1,
    loop: false,
    autoHeight: true,
    responsive: {
      576: {
        items: 1,
        autoHeight: true,
      },
      768: {
        items: 2,
        autoHeight: false,
      },
      1020: {
        items: 3,
        autoHeight: false,
      },
      1200: {
        items: 3,
        autoHeight: false,
      },
      1400: {
        items: 3,
        margin: 50,
        autoHeight: false,
      },
    },
    margin: 25,
    dots: false,
    nav: true,
    autoWidth: false,
    center: false,
    autoplay: false,
  };

  owl.owlCarousel(config);

  // re-init on resize
  $(window).resize(function () {
    if (!activeScrolling) {
      waitForFinalEvent(
        function () {
          owl.trigger("destroy.owl.carousel");
          owl.owlCarousel(config);
        },
        200,
        "newsHighlightSlider" + index
      );
    }
  });

  owl
    .closest(".js-carousel-section")
    .find(".js-owl-nav-prev")
    .on("click", function (e) {
      e.preventDefault();
      owl.trigger("stop.owl.autoplay");
      owl.trigger("prev.owl.carousel");
    });
  owl
    .closest(".js-carousel-section")
    .find(".js-owl-nav-next")
    .on("click", function (e) {
      e.preventDefault();
      owl.trigger("stop.owl.autoplay");
      owl.trigger("next.owl.carousel");
    });
});

//======================================================
// Copy to clipboard
$(".js-copy-clipboard").on("click", function (e) {
  let temp = $("<input>");
  let url = $(location).attr("href");
  let button = $(this);
  if (button.attr("data-url")) {
    url = button.attr("data-url");
  }

  e.preventDefault();
  $("body").append(temp);
  temp.val(url).select();
  document.execCommand("copy");
  temp.remove();
  $(this).addClass("js-copy-clipboard-success");
});

//======================================================
// Toggle media in news
$(".js-media-download-toogle").on("click", function (e) {
  e.preventDefault();

  $(this).attr(
    "aria-expanded",
    $(this).attr("aria-expanded") === "true" ? "false" : "true"
  );
  let container = $(this).closest("div").find(".js-media-download");
  if (container.length) {
    container.slideToggle(500);
  }
});

//======================================================
// Toggle searchbox
$(".js-searchbox-open").on("click", function (e) {
  e.preventDefault();

  let container = $(this).closest("div").find(".searchbox");
  if (container.length) {
    container.slideDown(500);
  }
  $("body").addClass("no-scroll");
});

$(".js-searchbox-close").on("click", function (e) {
  e.preventDefault();

  let container = $(this).closest(".searchbox");
  if (container.length) {
    container.slideUp(500);
  }
  $("body").removeClass("no-scroll");
});

//======================================================
// Custom selects
$(".js-select").select2({
  minimumResultsForSearch: 7,
});

$(window).resize(function () {
  if (!activeScrolling) {
    waitForFinalEvent(
      function () {
        if ($(document.activeElement).is('input') === false) {
          $(".js-select").select2("destroy").select2({
            minimumResultsForSearch: 7,
          });
        }
      },
      200,
      "select2"
    );
  }
});

//======================================================
// Datepicker
$(".form-date").datepicker({
  changeMonth: true,
  changeYear: true,
  defaultDate: +0,
  minDate: new Date(2020, 1 - 1, 1),
  inline: true,
  beforeShow: function (input, inst) {
    let rect = input.getBoundingClientRect();
    // use 'setTimeout' to prevent effect overridden by other scripts
    setTimeout(function () {
      let scrollTop = $("body").scrollTop();
      inst.dpDiv.css({ top: rect.top + input.offsetHeight + scrollTop });
    }, 0);
  },
});

if ($(".form-date").length && $(".form-date").first().attr("data-date-lang")) {
  $.datepicker.setDefaults(
    $.datepicker.regional[$(".form-date").first().attr("data-date-lang")]
  );
}

//======================================================
// Fit text to size of parent element
function setFontSizeViaJS() {
  $(".js-font-size").each(function () {
    $(this).css("font-size", $(this).parent().width() / 10);
  });
}

setFontSizeViaJS();
$(window).resize(function () {
  setFontSizeViaJS();
});

//======================================================

// Stop all videos on tab-change
$(".tab-container-tabs .nav-link").each(function () {
  $(this).on("click", function (e) {
    let container = $(this).closest(".tab-container-tabs");
    $.videoUtilities.stopAllVideos(container);
  });
});

//======================================================
// Adding offset to anchor-scroll because of fixed menu
function jumpToAnchor() {
  let anchorName = window.location.hash.replace("#", "");
  if (anchorName) {
    let anchor = $('a[name="' + anchorName + '"], #' + anchorName).first();
    let navBar = $("#page-top");

    if (anchor.length && navBar.length) {
      let scrollTo = anchor.position().top - navBar.outerHeight();
      if (anchor.find('#staff-header').length) {
        scrollTo = anchor.find('#staff-header').position().top - navBar.outerHeight();
        anchor.find('#staff-header .staff-container-link').click();

      }
      $("html, body").animate({ scrollTop: scrollTo }, 0);
    }
  }
}

// jump to anchor after all images are loaded
// this way we can calculate a correct position
$(window).on("load", function () {
  jumpToAnchor();
  $('.spacer-links a[href^="#"]').off();
  $('.spacer-links a[href^="#"]').on("click", function (e) {
    e.preventDefault();
    let navBar = $("#page-top");
    let anchorLink = $(e.target).attr("href");
    if (anchorLink && anchorLink.length > 1) {
      let anchorTarget = $(anchorLink);
      if (anchorTarget && navBar.length) {
        let scrollTo = anchorTarget.position().top - navBar.outerHeight();
        if (anchorTarget.find('#staff-header').length) {
          $('.js-flyout-close').click();
          if (anchorTarget.find('#staff-header .staff-container-link').attr('aria-expanded') == 'false') {
             anchorTarget.find('#staff-header .staff-container-link').click();
          }
          setTimeout(function(){
            window.scrollTo({
              top: anchorTarget.find('#staff-header').position().top - navBar.outerHeight(),
              behavior: "smooth",
            });
          }, 700);
        } else {
          $('.js-flyout-close').click();
          setTimeout(function(){
            window.scrollTo({
              top: anchorTarget.position().top - navBar.outerHeight(),
              behavior: "smooth",
            });
          }, 700);
        }
      }
    }
  });
});



$('a[href^="#"]').on("click", function (e) {
  e.preventDefault();
  let navBar = $("#page-top");
  let anchorLink = $(e.target).attr("href");
  if (anchorLink && anchorLink.length > 1) {
    let anchorTarget = $(anchorLink);
    if (anchorTarget && navBar.length) {
      let scrollTo = anchorTarget.position().top - navBar.outerHeight();
      if (anchorTarget.find('#staff-header').length) {
      } else {
      $("html, body").animate({ scrollTop: scrollTo }, 0);
      }
    }
  }
});

//======================================================
// Disable search if empty
/*$(".ke-search-sword").on("keyup", function (e) {
  let button = $(this).closest("fieldset").find(".ke-search-button").first();
  if ($(this).val().length < 4) {
    button.prop("disabled", true);
  } else {
    button.prop("disabled", false);
  }
});*/
//======================================================
// Press-download
$(".js-press-download").on("click", function (e) {
  let tile = $(this).closest(".js-tile-link-wrap");
  tile.data("href", tile.attr("href"));
  tile.attr("href", $(this).attr("data-href"));
  setTimeout(
    function (tile) {
      tile.attr("href", tile.data("href"));
    },
    250,
    tile
  );
});

//======================================================
// hide language dropdown on click outside
$(window).click(function () {
  if ($("#language-nav-dropdown").hasClass("open")) {
    $("#language-nav").dropdown("toggle");
  }
});

$("#language-nav").click(function (event) {
  event.stopPropagation();
});
$("#language-nav-dropdown").click(function (event) {
  event.stopPropagation();
});

//======================================================
// Init menus
$(".slide-nav-toggle").madj2kSlideMenu({
  menuItemsJson: slideNavItems,
  startOnHome: true,
});
$(".flyout-toggle").madj2kFlyoutMenu({
  paddingBehavior: 2,
  paddingViewPortMinWidth: 1920,
});

$(window).resize(function () {
  $(document).trigger("madj2k-slidemenu-close");
  $(document).trigger("madj2k-flyoutmenu-close");
});

//======================================================
// reduce menu on scroll
$(window).scroll(function () {
  if (
    !$("body").hasClass("no-scroll") &&
    !$("body").hasClass("no-scroll-overflow")
  ) {
    let navbar = $("#navbar");
    let topbar = $("#topbar");

    if ($(window).scrollTop() > 0) {
      if (!navbar.hasClass("reduced")) {
        navbar.addClass("reduced");
      }
      if (!topbar.hasClass("reduced")) {
        topbar.addClass("reduced");
      }
    } else {
      if (navbar.hasClass("reduced")) {
        navbar.removeClass("reduced");
      }
      if (topbar.hasClass("reduced")) {
        topbar.removeClass("reduced");
      }
    }
  }
});


//======================================================
// Load more for sustainable awards
const loadMoreButton = document.getElementsByClassName('load-awards')[0];
const awardList = document.querySelector('.award-blocks');

const loadMoreAwards = (e) => {
  e.preventDefault();
  let url = e.target.getAttribute("data-href");
  let body = [];
  document.getElementById('current-page').value = e.target.getAttribute('data-page');
  fetchAwards(url, body, false);
};

if (loadMoreButton != null) {
  loadMoreButton.addEventListener('click', loadMoreAwards, false);
}

function fetchAwards(url, body, filter) {
  const paginationClass = document.querySelector('.load-awards');
  if (paginationClass) {
    var paginationClassAwards = paginationClass.closest(".pagination-load-wrap");
    paginationClassAwards.innerHTML = '';
  }

  fetch(url, { method: 'POST', body })
    .then((resp) => resp.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const awardRecords = doc.querySelector('.award-blocks').innerHTML;
      if (filter === true) {
        awardList.innerHTML = awardRecords;
      } else {
        awardList.innerHTML += awardRecords;
      }

      const paginateWrapper = doc.querySelector('.load-awards');
      if (paginateWrapper) {
        const paginate = paginateWrapper.closest('.pagination-load-wrap').innerHTML;
        paginationClassAwards.innerHTML = paginate;
        const evtBtn = paginationClassAwards.querySelector('.load-awards');
        evtBtn.addEventListener('click', loadMoreAwards, false);
      }

    })
    .catch((error) => {
      console.log('Error ' + error.message);
    });
}


let contactModal = document.getElementById('contactModal');
if (contactModal) {
  contactModal.addEventListener('show.bs.modal', function (event) {
    $("body").prepend($("#contactModal"));
    $("#contactModal .modal-body-wrap").addClass('modal-body');
  })

  contactModal.addEventListener('shown.bs.modal', function (event) {
    $(".modal-backdrop").on('click', function () {
      $('#contactModal .btn-close').click();
    });
  });
}
